import type { ComponentProps } from "react";
import { cn } from "@/shared/lib/utils";

/** White card shell shared by all auth screens (sign in, reset, change). */
export function AuthCard({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "flex w-full max-w-[512px] flex-col gap-8 rounded-[32px] bg-(--schemes-surface-container-lowest) p-8 shadow-elevation-medium",
        className,
      )}
      {...props}
    />
  );
}
